import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject, Injectable} from "@angular/core";
import {HelperService} from "../../services/helper/helper.service";
import {CommonConstants} from "../../constants/common-constants";


@Injectable({
    providedIn: 'root'
})
export class checkLoginService {

    constructor(private helperService: HelperService, private router :Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
            if(this.helperService.checkLogin(CommonConstants.TOKEN)){
                this.router.navigate(['/dashboard']);
            }

    }
}

export const checkLoginGuardGuard:  CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
    return inject(checkLoginService).canActivate(next, state);
};
